import Invitations from './Invitations';

export default Invitations;
